module.exports = "<v-layout row wrap >\n  <vehicle-fleet-list/>\n</v-layout>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/block-vehicle-fleet/template.html
// module id = yISa
// module chunks = 0